<template>
  <v-app id="welcome-wrap">
    <div>
      <!-- Header -->
      <header-welcome></header-welcome>

      <!-- Contents -->
      <div class="contents">

        <div class="section-intro">
          <div class="intro">
            <div class="text-title">
              플랜
            </div>
          </div>
        </div>

        <div class="section-event">
          <!-- <div class="text-subtitle">
            2020년 프로모션
          </div> -->
          <div class="plans">
            <v-card class="plan" flat>
              <div>
                <div class="plan-title">베이직 플랜</div>
                <div>프로젝트 3개 계속 사용 가능</div>
              </div>
              <div class="plan-price">
                <span class="prices">
                  <span class="real-price">무료</span>
                </span>
              </div>
            </v-card>
            <v-card class="plan" flat>
              <div>
                <div class="plan-title">프리미엄 플랜</div>
              </div>
              <div class="plan-price">
                <span class="prices">
                  <span class="original-price"><del>월 11,800원</del></span>
                  <span class="real-price">월 6,800원</span>
                </span>
              </div>
            </v-card>
          </div>
        </div>

        <div>
            <v-card class="plan plan-selected" flat @click="register">
              <div>
                <div class="plan-title">회원가입하고 프리미엄 1개월 무료 사용하기</div>
                <div>카드 정보가 필요하지 않습니다</div>
              </div>
              <div class="plan-price">
                <span><v-icon color="white">mdi-chevron-right</v-icon></span>
              </div>
            </v-card>
        </div>

        <div class="section-table">
          <div class="table">
            <div class="text-subtitle">
              프리미엄 주요 기능
            </div>

            <table class="table-features">
              <tbody>
                <tr v-for="(value, index) in features"
                  :key="index">
                  <td :class="{'tbody-header-bold':!value.confirm, 'tbody-header':!!value.name, 'tbody-header-empty':!value.name}">
                    {{ value.name }}
                  </td>
                  <td :class="{'tbody-contents':!!value.name, 'tbody-contents-empty':!value.name}">
                    <v-icon v-if="value.confirm">mdi-check</v-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <footer-welcome></footer-welcome>
    </div>
  </v-app>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "Plans"
    }
  },

  data() {
    return {
      features: [
        { name: '프로젝트 조직', confirm: false },
        { name: '프로젝트 무제한 생성', confirm: true },
        { name: '프로젝트 목록 뷰 모드 제공', confirm: true },
        { name: '프로젝트 이미지 개인화', confirm: true },
        { name: '종료 프로젝트 보관', confirm: true },
        { name: null, confirm: false },
        { name: '도큐먼트 관리', confirm: false },
        { name: '.enw, .ris 파일 업로드', confirm: true },
        { name: '서지사항 공유를 통한 in-app 검색', confirm: true },
        { name: '도큐먼트 목록 뷰 모드 제공', confirm: true },
        { name: '날짜, 제목, 저자로 정렬 및 검색', confirm: true },
        { name: '중요한 도큐먼트 표시', confirm: true },
        { name: null, confirm: false },
        { name: '노트 작성', confirm: false },
        { name: '워드 파일로 추출', confirm: true },
        { name: '도큐먼트 리뷰와 프로젝트 노트 동시 작성', confirm: true },
        { name: '도큐먼트 리뷰 일괄 관리', confirm: true },
        { name: '웹 기반으로 어디서나 동기화', confirm: true },
        { name: null, confirm: false },
        { name: '레퍼런스 트리 활용', confirm: false },
        { name: '다양한 트리 모드와 가이드 제공', confirm: true },
        { name: '도큐먼트 추천 기능', confirm: true },
        { name: '도큐먼트에 레퍼런스 추가', confirm: true },
      ],

      products: [
        { name: '1년이용권', event: '18,000원'},
        { name: '평생이용권', event: '99,000원'},
      ],
    }
  },

  methods: {
    register() {
      let access_token = this.$store.getters['auth/access_token']
      if (!!access_token) {
        this.$router.push({name: 'lab'})
      }
      else {
        this.$store.commit('welcome/setEmail', this.email)
        this.$router.push({name: 'signup'})
      }
    },
  }
}
</script>

<style scoped>

  .contents {
    -moz-box-align: center;
    -moz-box-orient: vertical;
    -ms-flex-align: center;
    -ms-flex-direction: column;
    -o-box-align: center;
    -o-box-orient: vertical;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -webkit-box-orient: vertical;
    -webkit-flex-direction: column;
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 1080px;
    min-width: 327px;
    width: 95%;
  }

  .section-intro {
    -moz-box-align: center;
    -moz-box-orient: horizontal;
    -moz-box-pack: justify;
    -ms-flex-align: center;
    -ms-flex-direction: row;
    -ms-flex-pack: justify;
    -o-box-align: center;
    -o-box-orient: horizontal;
    -o-box-pack: justify;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -webkit-box-orient: horizontal;
    -webkit-box-pack: justify;
    -webkit-flex-direction: row;
    -webkit-justify-content: center;
    align-items: center;
    display: -webkit-box;
    display: -moz-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    padding: 60px 0px 50px;
  }

  .section-box {
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 1000px;
    width: 100%;
    margin-top: 40px;
    margin-bottom: 60px;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .box-header {
    display: flex;
    align-items: center;
    align-self: flex-start;
    background-color: #e0457a;
    color: #ffffff;
    height: 30px;
    margin-top: -30px;
    padding-left: 40px;
    padding-right: 40px;
    font-size: 14px;
    font-weight: 600;
  }

  .box-contents {
    margin: 0;
    width: 100%;
    border: 4px solid #e0457a;
  }

  .box-contents-inner {
    padding: 40px 35px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .box-header-text {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 6px;
  }

  .box-title-text {
    font-size: 30px;
  }

  .price {
    margin-top: 6px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .original-price {
    font-size: 18px;
    color: #B3A8B5;
    margin-right: 3px;
  }
  
  .real-price {
    font-size: 20px;
    font-weight: 600;
  }

  .btn-text {
    padding: 0 30px;
  }

  .btn-meta {
    margin-top: 6px;
    text-align: center;
  }

  .section-event {
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 1000px;
    width: 100%;
    margin-bottom: 30px;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .plans {
    display: flex;
    flex-direction: row;
    width: 100%;
    max-width: 1000px;
  }

  .plan {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px;
    background-color: rgba(237, 237, 237, 0.4) !important;
    margin: 10px;
  }

  .plan-selected {
    background-color: #E0457A !important;
    color: white !important;
  }

  .plan-bold {
    border: #E0457A 3px solid !important;
  }

  .plan-title {
    font-size: 16px;
    font-weight: 600;
  }

  .plan-price {
    font-size: 20px;
    font-weight: 600;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .text-title {
    text-align: center;
    margin: 14px 0 0;
    font: normal 500 40px/48px 'Spoqa Han Sans', 'Sans-serif' !important;
    letter-spacing: -.2px;
  }

  .text-subtitle {
    text-align: center;
    margin: 35px 0 25px;
    font: normal 400 28px/36px 'Spoqa Han Sans', 'Sans-serif' !important;
    letter-spacing: 0;
  }

  .explanation {
    background: linear-gradient(180deg, rgba(255,255,255,0) 85%, rgb(224,69,122) 85%);
    padding-bottom: 10px;
  }

  .divider {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 20px 0;
    font-size: 16px;
  }

  .text-meta {
    font-size: 20px;
    text-align: center;
    margin: 10px 20px 25px;
  }

  .intro-btn {
    margin-top: 60px;
  }

  .section-table {
    width: 100%;
    margin-bottom: 120px;
  }

  .table {
    width: 1080px;
    margin: 0px auto;
  }

  .table-features {
    width: 1080px;
    margin: 0px auto;
    table-layout: fixed;
    border-collapse: initial;
    font-size: 16px;
  }

  .thead-header {
    width: 40%;
    vertical-align: bottom;
  }

  .thead-contents {
    border-left: 1px dotted rgba(55, 53, 47, 0.09);
    padding-left: 15px;
    padding-right: 15px;
    vertical-align: top;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: 0px;
    background: transparent;
  }

  .event {
    font-weight: 700;
  }

  .contents-title {
    font-size: 24px;
  }

  .contents-price {
    display: flex;
    flex-direction: row;
  }

  .tbody-header {
    border-bottom: 1px solid rgba(55, 53, 47, 0.09);
    padding-right: 10px;
    padding-top: 7px;
    padding-bottom: 8px;
    text-align: center;
  }

  .tbody-header-bold {
    font-weight: 700;
  }

  .tbody-contents {
    border-bottom: 1px solid rgba(55, 53, 47, 0.09);
    border-left: 1px dotted rgba(55, 53, 47, 0.09);
    padding-left: 15px;
    padding-right: 15px;
    text-align: center;
    overflow: hidden;
    background: transparent;
  }

  .tbody-header-empty {
    padding-bottom: 7px;
    padding-right: 15px;
    font-weight: 500;
    vertical-align: bottom;
    padding-top: 10px;
  }

  .tbody-contents-empty {
    padding-bottom: 7px;
    padding-right: 15px;
    font-weight: 500;
    vertical-align: bottom;
    padding-top: 10px;
    border-left: 1px dotted rgba(55, 53, 47, 0.09);
    background: transparent;
  }
  
  @media (max-width: 1080px) {
    .table, .table-features {
      width: 100%;
    }

    .section-box {
      max-width: 650px;
    }

    .box-contents-inner {
      flex-direction: column;
    }

    .price {
      margin-bottom: 20px;
    }

    .plans {
      flex-direction: column;
      max-width: 650px;
    }

    .plan {
      margin: 10px 0;
    }

    .prices {
      display: flex;
      flex-direction: column;
    }
  }


  @media (max-width: 1080px) {
    .table, .table-features {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/spa/welcome/Plans.vue